import { getDashboardFeed as getDashboardFeedService } from '@simplywallst/services';
import { withAuth } from '@utilities/queries';

export const queryFn = async (refresh = false) => {
  const res = await withAuth(getDashboardFeedService, { refresh });
  const { data } = res.data;
  return data;
};
